import React, { Component } from 'react'
import Page404 from '../../old_Components/Page404/Page404'
import constant from '../../constant'
export default class page404 extends Component {
    constructor(props){
        super(props);
        this.state = {

        }

    }
    componentDidMount(){
        document.title = constant.title.Page404
    }
  render() {
    return (
      <React.Fragment>
        <Page404/>
      </React.Fragment>
    )
  }
}
